import { useState, useEffect } from 'react';

/**
 * Hook to handle Quick Time Event logic in chat
 * @param {Array} messages - The current chat messages
 * @returns {Object} - Quick time event state and handlers
 */
const useQuickTimeEvents = (messages) => {
  const [isQuickTimeEvent, setIsQuickTimeEvent] = useState(false);
  
  // Fixed QTE card texts
  const QTE_SUGGESTIONS = [
    "Let's pick up where we left off.",
    "Talk about something else..."
  ];
  
  // Check if all messages have the isQuickTimeEvent flag
  useEffect(() => {
    // Skip check if there are no messages
    if (!messages || messages.length === 0) {
      setIsQuickTimeEvent(false);
      return;
    }
    
    // If the most recent message is from the user, disable QTE mode
    const lastMessage = messages[messages.length - 1];
    if (lastMessage.sender === 'user') {
      if (isQuickTimeEvent) {
        console.log('Quick Time Event mode exited - user sent a message');
        setIsQuickTimeEvent(false);
      }
      return;
    }
    
    // Check if all messages have isQuickTimeEvent flag set to true
    const allMessagesAreQTE = messages.every(message => message.isQuickTimeEvent === true);
    
    // Update state only if it changed
    if (allMessagesAreQTE !== isQuickTimeEvent) {
      setIsQuickTimeEvent(allMessagesAreQTE);
      
      // Debug log
      if (allMessagesAreQTE) {
        console.log('Quick Time Event mode activated - using special suggestion cards');
      } else if (isQuickTimeEvent) {
        console.log('Quick Time Event mode deactivated - returning to normal mode');
      }
    }
  }, [messages, isQuickTimeEvent]);
  
  return {
    isQuickTimeEvent,
    qteOverlayText: "For this message, use the cards above.",
    qteSuggestions: QTE_SUGGESTIONS
  };
};

export default useQuickTimeEvents; 